exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-base);\n}\n.email-form__suggestion {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--size-sm);\n}\n.email-form__email {\n  font-weight: 700;\n}\n.email-form__action {\n  color: var(--blue-700);\n  font-weight: 700;\n  text-decoration: underline;\n  cursor: pointer;\n  background: transparent;\n  font-family: inherit;\n  border: none;\n  padding: 0;\n}", ""]);

// exports
